import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'ProductReceiptId',
        caption: 'Receipt',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        alignment: 'left'
    },
    {
        dataField: 'SupplierIdDisplay',
        caption: 'Supplier',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'Name',
        caption: 'Name',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'Username',
        caption: 'Username',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'Entered',
        caption: 'Entered',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0
    },
    {
        dataField: 'TimeDisplay',
        caption: 'Time',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm1
    },
    {
        dataField: 'Note',
        caption: 'Notes',
        minWidth: COLUMN_SIZE.xl0,
        width: COLUMN_SIZE.xl0
    }
];
